import Vue from 'vue'

const OFFER_LOADED = (state, data) => {
  state.template = data
  try {
    let analyticstype = Vue.prototype.$whitelabel.analyticsType

    if (analyticstype == 'gtag' || analyticstype == 'both') {
      this.$gtag.event('view_item_list', {
        event_category: 'ecommerce',
        event_label: 'Search',
        items: [
          {
            id: data.id,
            name: `${data.contact.name} - ${data.title}`,
            category: 'Urlaubsgutschein',
            brand: data.vendor.name,
            list_name: 'Sucheresultat',
            list_position: 1,
            quantity: 1,
          },
        ],
      })

      this.$gtag.pageview()
    }

    if (analyticstype == 'ua' || analyticstype == 'both') {
      Vue.$ga.ecommerce.addProduct({
        id: data.id,
        name: `${data.contact.name} - ${data.title}`,
        category: 'Urlaubsgutschein',
        brand: data.vendor.name,
      })
      Vue.$ga.ecommerce.setAction('detail')
      //Vue.$ga.send('pageview')
    }
  } catch {
    //todo some logging mechanism i guess
  }
}

const OFFER_FETCHING = state => {
  state.notFound = false
}

const OFFER_NOT_FOUND = state => {
  state.notFound = true
}

const STATIC_DATA_CACHE_RESET = state => {
  state.staticStorage = null
}

const OFFER_DATA_RECEIVED = (state, data) => {
  state.staticStorage = data
}

const FURTHER_OFFERS_LOADED = (state, data) => {
  state.furtherOffers = data
}

export default {
  OFFER_LOADED,
  OFFER_FETCHING,
  OFFER_NOT_FOUND,
  FURTHER_OFFERS_LOADED,
  OFFER_DATA_RECEIVED,
  STATIC_DATA_CACHE_RESET,
}
